import { useLocation } from 'react-router-dom';
import Header from './Header';

const CardzoneFailure = () => {
  const query = new URLSearchParams(useLocation().search);
  const code = query.get('code');
  const msg = query.get('msg');

  return (
    <>
    <Header></Header>
     <div className="mt-24 p-10 text-center">
      <h1 className="text-3xl font-bold text-red-600">❌ Payment Failed</h1>
      <p className="mt-4 text-lg">Code: {code}</p>
      <p className="text-md text-gray-700">Reason: {msg}</p>
    </div>
    </>
   
  );
};

export default CardzoneFailure;
